export default __webpack_public_path__ + "media/images/svg/bone-decor-orange-458ebc8fe400e31a581c38d3c3040492.svg";